import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FadeIn } from "@/components/Reveal";

const FAQS = [
  {
    q: "Does TSM Group CLE only provide compliance consulting?",
    a: "No. TSM Group CLE combines business compliance support with operational services including workforce verification, drug testing, fingerprinting, notary services, screening support, documentation, and mobile business services.",
  },
  {
    q: "Can TSM come to our business location?",
    a: "Many services can be provided onsite depending on the type of service and location.",
  },
  {
    q: "Can small businesses use TSM Group CLE?",
    a: "Yes. TSM works with startups, small businesses, growing companies, employers, contractors, and professional organizations.",
  },
  {
    q: "Can TSM help us create Standard Operating Procedures?",
    a: "Yes. TSM Group CLE can assist businesses with documenting repeatable processes and creating Standard Operating Procedures designed around their operations.",
  },
  {
    q: "Do you provide I-9 verification services?",
    a: "TSM Group CLE provides I-9 Authorized Representative and verification support services. Employers remain responsible for properly completing and maintaining Form I-9 in accordance with applicable requirements.",
  },
  {
    q: "Does TSM provide legal advice?",
    a: "No. TSM Group CLE provides business compliance and operational support services and does not provide legal advice.",
  },
];

export const FAQ = () => (
  <section id="faq" className="bg-white py-24 lg:py-32">
    <div className="container-tsm grid gap-14 lg:grid-cols-12">
      <FadeIn className="lg:col-span-4">
        <p className="eyebrow">FAQ</p>
        <h2
          className="mt-6 font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl"
          data-testid="faq-headline"
        >
          Frequently Asked Questions
        </h2>
        <p className="mt-6 max-w-sm leading-relaxed text-ink/65">
          Can&rsquo;t find what you&rsquo;re looking for? <a href="#request" className="font-semibold text-navy underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-gold" data-testid="faq-contact-link">Send a service request</a> and our team will follow up.
        </p>
      </FadeIn>

      <FadeIn delay={0.15} className="lg:col-span-7 lg:col-start-6">
        <Accordion type="single" collapsible className="border-t border-navy/10" data-testid="faq-accordion">
          {FAQS.map((faq, i) => (
            <AccordionItem key={faq.q} value={`faq-${i}`} className="border-b border-navy/10">
              <AccordionTrigger
                className="py-6 text-left font-serif text-xl font-semibold leading-snug text-navy hover:no-underline hover:text-golddark sm:text-2xl [&>svg]:text-gold [&>svg]:h-5 [&>svg]:w-5"
                data-testid={`faq-question-${i + 1}`}
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-ink/70" data-testid={`faq-answer-${i + 1}`}>
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeIn>
    </div>
  </section>
);
